import { IAffiliateSubLink } from 'entities/Link';
import { ESourceRelationStatuses, ETrafficConditions } from 'entities/Offer';
import { ISource } from 'entities/Source';
import { IBaseResponse, ICategory, ICountry, ICurrency, ITag, ITrafficType } from 'shared/typings';

export enum EOfferRateTypes {
	FIXED = 'fixed',
	PERCENT = 'percent',
}

export interface IOfferTraffikType {
	traffic_type: ITrafficType;
	condition: ETrafficConditions;
}

export interface ICreative {
	name: string;
	url: string;
	updated_at: string;
}

export interface ISourceRelation {
	source: Pick<ISource, 'uuid' | 'name'>;
	status: ESourceRelationStatuses;
	rejection_comment?: string;
	affiliate_links?: IAffiliateSubLink[] | null;
	erid?: string | null;
	rejected_count: number;
}

export interface IOfferCountry {
	country: ICountry;
	comment: string;
}

export interface IActualRate {
	name: string;
	payout_size: number;
	type: EOfferRateTypes.FIXED | EOfferRateTypes.PERCENT;
	description: string;
}

export interface IOfferLanding {
	code: string;
	name: string;
	url: string;
}

export interface IOffer {
	uuid: string;
	brand: {
		uuid: string;
		name: string;
	};
	slug: string;
	image: string;
	name: string;
	epc: string;
	cr: string;
	ar: string;
	money_transfer_time: string;
	currency: ICurrency;
	categories: ICategory[];
	tags: ITag[];
	description: string;
	negative_words: string;
	traffic_types: IOfferTraffikType[];
	creatives: ICreative[];
	countries: IOfferCountry[];
	sources_relations: ISourceRelation[];
	grouped_rates: {
		fixed_payout_size?: string;
		percent_payout_sizes?: string;
	};
	actual_rates: IActualRate[] | null;
	updating_statistics: string;
	landings?: IOfferLanding[];
}

export type TOfferList = IBaseResponse<IOffer[] | null>;
